module.exports = __webpack_public_path__ + "static/media/CV.004cd907.pdf";